import CryptoJS from 'crypto-js';

// 加密密钥，可按需修改
const SECRET_KEY = 'yongsi-secret-key-20250609'; 

// 加密 JSON 数据
export function encryptJson(data) {
  const jsonString = JSON.stringify(data);
  const encrypted = CryptoJS.AES.encrypt(jsonString, SECRET_KEY).toString();
  return encrypted;
}

// 解密 JSON 数据
export function decryptJson(encryptedData) {
  const bytes = CryptoJS.AES.decrypt(encryptedData, SECRET_KEY);
  const decryptedString = bytes.toString(CryptoJS.enc.Utf8);
  try {
    return JSON.parse(decryptedString);
  } catch (error) {
    console.error('解密失败:', error);
    return null;
  }
}